module.exports = __webpack_public_path__ + "img/lecrans-hotel-&-spa-social-media-management.22907ffb.jpg";